<template>
  <div id="home">
  	<home-header :navName="navName"></home-header>
  	<div id="bodyer">
  		<div class="banner">
        <div class="swiper-container">
          <div class="swiper-wrapper bannerImg">
            <div class="swiper-slide">
              <img src="../assets/images/home/banner1.jpg" alt="">
              <div class="words">
                <p class="bigWord">观古今于须臾，抚四海于一瞬</p>
                <p class="wordTip">基于云计算、时空大数据，助您了解地理多维信息</p>
                <div class="seeMore">
                  <router-link to="/map">查看详情</router-link>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <img src="../assets/images/home/banner2.png" alt="">
              <div class="words">
                <p class="bigWord">时空全息大数据平台</p>
                <p class="wordTip">新一代地理信息可视化、分析与管理的位置智能服务平台</p>
                <div class="seeMore">
                  <router-link to="/xqapp">查看详情</router-link>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <img src="../assets/images/home/banner3.png" alt="">
              <div class="words">
                <p class="bigWord">行业解决方案</p>
                <p class="wordTip">量身定制、简单快捷</p>
                <div class="seeMore">
                  <router-link to="/solution">查看详情</router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <div class="menu">
        <div class="title">集地图、平台、应用与装备于一体的地图大数据平台</div>
        <div class="titleTip">秉承“探索时空规律，共享地理智慧”的理念，致力于为用户提供准确、专业、高效的产品及服务</div>
        <ul class="menuList">
          <li class="map" @click="menuStatu=1" :class="{active: menuStatu==1}">地图</li>
          <li class="yinQing" @click="menuStatu=2" :class="{active: menuStatu==2}">平台</li>
          <li class="yingYong" @click="menuStatu=3" :class="{active: menuStatu==3}">应用</li>
          <li class="zhuangBei" @click="menuStatu=4" :class="{active: menuStatu==4}">装备</li>
        </ul>
        <ul class="listContent">
          <li class="map" :class="{active: menuStatu==1}">
            <div class="gnLeft">
              <div class="gnTitle">地图</div>
              <p class="gnTitleTip">海量数据可视化的地图产品，契合不同业务场景，让更多人体验精彩地图</p>
              <div class="gnDetail"><button><router-link to="/map">了解详情</router-link></button></div>
            </div>
            <div class="gnRight">
              <img src="../assets/images/home/map.png" alt="">
            </div>
          </li>
          <li class="yinQing" :class="{active: menuStatu==2}">
            <div class="gnLeft">
              <div class="gnTitle">平台</div>
              <p class="gnTitleTip">平台描述</p>
              <div class="gnDetail"><button><router-link to="/engine">了解详情</router-link></button></div>
            </div>
            <div class="gnRight">
              <img src="../assets/images/home/yinqing.png" alt="">
            </div>
          </li>
          <li class="yingYong" :class="{active: menuStatu==3}">
            <div class="gnLeft">
              <div class="gnTitle">应用</div>
              <p class="gnTitleTip">应用描述</p>
              <div class="gnDetail"><button><router-link to="/xqapp">了解详情</router-link></button></div>
            </div>
            <div class="gnRight">
              <img src="../assets/images/home/yingyong.png" alt="">
            </div>
          </li>
          <li class="zhuangBei" :class="{active: menuStatu==4}">
            <div class="gnLeft">
              <div class="gnTitle">装备</div>
              <p class="gnTitleTip">装备描述</p>
              <div class="gnDetail"><button><router-link to="/facilityCloud">了解详情</router-link></button></div>
            </div>
            <div class="gnRight">
              <img src="../assets/images/home/zhuangbei.png" alt="">
            </div>
          </li>
        </ul>
      </div>

      <div class="anLi">
        <div class="anLiTitle">用户案例</div>
        <div class="anLiTip">根据用户实际需求量身定制解决方案，专注于创建优雅和快速响应的业务用户体验</div>

<div class="box">

  <div class="list">
    <ul>
      <!--<li class="p6"><a href="javascript:;"><img src="../assets/images/solution/2.png" alt="" /></a><div class="shuoMing">
                <p class="name">分队作战解决方案</p>
                <p class="fangAn">在未来的信息化战争中，作战分队单兵之间，单兵与分队指挥员之间的战场态势信息和其他信息的互联互通问题都离不开单兵...</p>
              </div></li>-->
      <li class="p5"><a href="javascript:;"><img src="../assets/images/solution/3.png" alt="" /></a><div class="shuoMing">
                <p class="name">野外数据采集解决方案</p>
                <p class="fangAn">野外数据采集解决方案面向野外信息采集行动，集硬件、软件、数据和服务于一体，旨在为采集团队提供智能便携的地图数据...</p>
              </div></li>
      <li class="p4"><a href="javascript:;"><img src="../assets/images/solution/1.png" alt="" /></a><div class="shuoMing">
                <p class="name">科学大数据管理解决方案</p>
                <p class="fangAn">科学大数据管理解决方案是在网络化运行环境下，采用统一用户认证与权限控制，遵循分级管理、安全可控、充分利用的原则...</p>
              </div></li>
      <!--<li class="p3"><a href="javascript:;"><img src="../assets/images/solution/2.png" alt="" /></a><div class="shuoMing">
                <p class="name">分队作战解决方案</p>
                <p class="fangAn">在未来的信息化战争中，作战分队单兵之间，单兵与分队指挥员之间的战场态势信息和其他信息的互联互通问题都离不开单兵...</p>
              </div></li>-->
      <li class="p2"><a href="javascript:;"><img src="../assets/images/solution/3.png" alt="" /></a><div class="shuoMing">
                <p class="name">野外数据采集解决方案</p>
                <p class="fangAn">野外数据采集解决方案面向野外信息采集行动，集硬件、软件、数据和服务于一体，旨在为采集团队提供智能便携的地图数据...</p>
              </div></li>
      <li class="p1"><a href="javascript:;"><img src="../assets/images/solution/1.png" alt="" /></a><div class="shuoMing">
                <p class="name">科学大数据管理解决方案</p>
                <p class="fangAn">科学大数据管理解决方案是在网络化运行环境下，采用统一用户认证与权限控制，遵循分级管理、安全可控、充分利用的原则...</p>
              </div></li>
    </ul>
  </div>

  <a href="javascript:;" class="prev btn"><img src="../assets/images/home/left_arrow.png" alt=""></a>
  <a href="javascript:;" class="next btn"><img src="../assets/images/home/right_arrow.png" alt=""></a>

  <div class="buttons">
    <a href="javascript:;"><span class="blue"></span></a>
    <a href="javascript:;"><span></span></a>
    <a href="javascript:;"><span></span></a>
    <a href="javascript:;"><span></span></a>
    <a href="javascript:;"><span></span></a>
    <a href="javascript:;"><span></span></a>
    <a href="javascript:;"><span></span></a>
  </div>
</div>

        <div class="moreAnli">
          <a><router-link to="/solution">更多客户案例 >></router-link></a>
        </div>
      </div>
      <div class="news">
        <div class="title">新闻资讯</div>
        <div class="titleTip">快速了解新闻事件、热点话题、人物动态、产品资讯</div>
        <ul class="newsList">
          <li class="nws" v-for="newsdata in newsdatas">
            <div class="date">
              <p class="tian"></p>
              <p class="yue"></p>
            </div>
            <div class="newsContent">
              <router-link to="/about"><div class="title"></div></router-link>
              <div class="content"></div>
            </div>
          </li>
        </ul>
        <div class="more_news"><span><router-link to="/about"><img src="../assets/images/home/more_news.png" alt=""></router-link></span></div>
      </div>

      <div class="heZuo">
        <div class="title">合作伙伴</div>
        <div class="tip">竭诚合作、以德经营、互利互赢、共同发展</div>
        <ul class="partners">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
  	</div>

    <connect-part></connect-part>
    <home-footer></home-footer>
  </div>
</template>
<script>
import axios from 'axios'
import HomeHeader from './components/header'
import ConnectPart from './components/connect'
import HomeFooter from './components/footer'
export default {
  name: 'facilityCloud',
  components:{
    HomeHeader:HomeHeader,
  	ConnectPart:ConnectPart,
    HomeFooter:HomeFooter
  },
  data() {
  		return {
  			listdata:"",
  			navName:"layout",
        lianXi:false,
        goTopStatus: 0,
        menuStatu: 1,
        newsdatas:[]
  		}
  },
  methods:{
  	getGcmsList:function(){
      var that = this;
      var url = xdc_app_config.gcms_server+'/content/about_news';
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json'
      })
      .done(function(data) {
        // console.log(data);
        var aboutData = data.data;
          $(aboutData).each(function(j,item){
            var innerUrl = xdc_app_config.gcms_server+'/content/about_news/'+item.gcms_id;
            $.ajax({
              url: innerUrl,
              type: 'GET',
              dataType: 'json'
            })
            .done(function(data) {
              // console.log(data);
              if(data.data){
                that.updateData(data.data,'about_news')
              }
            })
            .fail(function() {
              // console.log("error");
            })
          })
      })
      .fail(function() {
        // console.log("error");
      })
    },
  	updateData:function(data,activeAbout){
      var that = this;
      var aboutData = data;
      var options = {};
      if(aboutData && activeAbout == "about_news"){
        // console.log("news");
        // console.log(aboutData);
        options.gcms_title = aboutData.gcms_title;
        options.introduction = aboutData.introduction;
        options.content = aboutData.content;
        var date = new Date(aboutData.time);
        options.year = 1900 + date.getYear();
        var m = "0"+(date.getMonth()+1);
        options.month = m.substring(m.length-2,m.length);
        var d = "0"+date.getDate();
        options.day = d.substring(d.length-2,d.length);

        that.unique5(that.newsdatas);
        that.newsdatas.push(options);
        // console.log(options);
        setTimeout(function(){
          that.showDetail();
        },500)

      }
    },
    showDetail:function(){
      var that = this;
      for(var i=0;i<that.newsdatas.length;i++){
        $(".nws .tian").eq(i).html(that.newsdatas[i].day);
        $(".nws .day").eq(i).html(that.newsdatas[i].day);
        $(".nws .yue").eq(i).html(that.newsdatas[i].month);
        $(".nws .month").eq(i).html(that.newsdatas[i].month);
        $(".nws .year").eq(i).html(that.newsdatas[i].year);
        $(".nws .title").eq(i).html(that.newsdatas[i].gcms_title);
        $(".nws .Dtitle").eq(i).html(that.newsdatas[i].gcms_title);
        $(".nws .content").eq(i).html(that.newsdatas[i].introduction);
      }
      $(".nws .title").bind("click",function(){
        //打开对应文章详情
        // window.location.href = "/#about";
      })
    },
    unique5: function(array){
      var r = [];
      for(var i = 0, l = array.length; i < l; i++) {
       for(var j = i + 1; j < l; j++)
        if (array[i] === array[j]) j = ++i;
       r.push(array[i]);
       }
       return r;
    },
    gotoTop: function() {
        window.scroll(0,0);
        this.goTopStatus = 0;
    },
    snap: function(sessionChannelsOffset) {
        if (window.scrollY >= sessionChannelsOffset) {
            this.goTopStatus = 1;
        } else {
            this.goTopStatus = 0;
        }
    },
    anliLunbo: function(){
      var $a=$(".box .buttons a");
      var $s=$(".box .buttons span");
      var cArr=["p6","p5","p4","p3","p2","p1"];
      var index=0;
      $(".box .next").click(
        function(){
        nextimg();
        }
      )
      $(".box .prev").click(
        function(){
        previmg();
        }
      )
      //上一张
      function previmg(){
        cArr.unshift(cArr[6]);
        cArr.pop();
        //i是元素的索引，从0开始
        //e为当前处理的元素
        //each循环，当前处理的元素移除所有的class，然后添加数组索引i的class
        $(".box li").each(function(i,e){
          $(e).removeClass().addClass(cArr[i]);
        })
        index--;
        if (index<0) {
          index=6;
        }
        show();
      }

      //下一张
      function nextimg(){
        cArr.push(cArr[0]);
        cArr.shift();
        // console.log(cArr)
        $(".box li").each(function(i,e){
          $(e).removeClass().addClass(cArr[i]);
        })
        index++;
        if (index>6) {
          index=0;
        }
        show();
      }

      //通过底下按钮点击切换
      $a.each(function(){
        $(this).click(function(){
          var myindex=$(this).index();
          var b=myindex-index;
          if(b==0){
            return;
          }
          else if(b>0) {
            /*
             * splice(0,b)的意思是从索引0开始,取出数量为b的数组
             * 因为每次点击之后数组都被改变了,所以当前显示的这个照片的索引才是0
             * 所以取出从索引0到b的数组,就是从原本的这个照片到需要点击的照片的数组
             * 这时候原本的数组也将这部分数组进行移除了
             * 再把移除的数组添加的原本的数组的后面
             */
            var newarr=cArr.splice(0,b);
            cArr=$.merge(cArr,newarr);
            $(".box li").each(function(i,e){
            $(e).removeClass().addClass(cArr[i]);
            })
            index=myindex;
            show();
          }
          else if(b<0){
            /*
             * 因为b<0,所以取数组的时候是倒序来取的,也就是说我们可以先把数组的顺序颠倒一下
             * 而b现在是负值,所以取出索引0到-b即为需要取出的数组
             * 也就是从原本的照片到需要点击的照片的数组
             * 然后将原本的数组跟取出的数组进行拼接
             * 再次倒序,使原本的倒序变为正序
             */
            cArr.reverse();
            var oldarr=cArr.splice(0,-b)
            cArr=$.merge(cArr,oldarr);
            cArr.reverse();
            $(".box li").each(function(i,e){
            $(e).removeClass().addClass(cArr[i]);
            })
            index=myindex;
            show();
          }
        })
      })

      //改变底下按钮的背景色
      function show(){
          $($s).eq(index).addClass("blue").parent().siblings().children().removeClass("blue");
      }

      //点击class为p2的元素触发上一张照片的函数
      $(document).on("click",".box .p2",function(){
        previmg();
        return false;//返回一个false值，让a标签不跳转
      });

      //点击class为p4的元素触发下一张照片的函数
      $(document).on("click",".box .p4",function(){
        nextimg();
        return false;
      });

      //      鼠标移入box时清除定时器
      $(".box").mouseover(function(){
        clearInterval(timer);
      })

      //      鼠标移出box时开始定时器
      $(".box").mouseleave(function(){
        timer=setInterval(nextimg,4000);
      })

      //      进入页面自动开始定时器
      var timer=setInterval(nextimg,4000);


    }
  },
  mounted:function(){
    var that = this;
    var swiper = new Swiper('.swiper-container', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    setTimeout(function(){
      that.getGcmsList();
    },500)
    var timeoutId = null;
    window.addEventListener("scroll", function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
         }
        timeoutId = setTimeout(that.snap, 10, 300);
    });
    this.anliLunbo();

  }
}
</script>
<style scoped>
@import "../assets/styles/home.css";
.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{
  width: 14px !important;
  height: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue